import type {
  AttachedEmbedWithChangedState,
  AttachedMediaWithChangedState,
  AttachedMediaWithChangedStateAndEmbed,
} from 'app/general/widgets/ImagesCarousel/types';

export function isAttachedMedia(
  media: AttachedMediaWithChangedStateAndEmbed
): media is AttachedMediaWithChangedState {
  return 'image_ref' in media || 'embed_ref' in media;
}

export function isEmbeddedMedia(
  media: AttachedMediaWithChangedStateAndEmbed
): media is AttachedEmbedWithChangedState {
  return 'embed_html' in media;
}
